import './PeriscopeWorkflowRuleCriteria.scss';
import { CodeHighlight } from '@ui/general';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';
export const PeriscopeWorkflowRuleCriteria = ({ criteria = [], index, isFormula }) => {
    if (!criteria.length) {
        return null;
    }
    const title = isFormula ? COPY_SPECIFIC.FORMULA : COPY_SPECIFIC.CRITERIA;
    return (React.createElement("div", { className: 'workflow-rule-criteria' },
        React.createElement("b", null, title),
        criteria.map((row) => React.createElement(CodeHighlight, { code: row.code, codeReferences: row.codeReferences, index: index, key: row.code }))));
};
